'use client'

import { assign } from 'lodash-es'
import { useEffect } from 'react'
import { useMapboxContext } from '../../map/context'
import { boundaryToLngLat } from '../../utils'
import PropTypes from 'prop-types'
import bbox from '@turf/bbox'

export default function MapboxPolygon({
  paths,
  autofitbounds = false,
  color = '#FF8500',
  name,
}) {
  const { id, map, mapLoaded } = useMapboxContext()
  const polygonId = `${id}-${name}-polygon`
  const outlineId = `${polygonId}-${name}-outline`

  useEffect(() => {
    if (!mapLoaded) return

    addPolygon({ autofitbounds, color, polygonId, outlineId })(map, paths)
    return () => {
      map.removeLayer(polygonId)
      map.removeLayer(outlineId)
      map.removeSource(polygonId)
      map.removeSource(outlineId)
    }
  }, [mapLoaded, map, id, autofitbounds, color, paths, polygonId, outlineId])

}

function addPolygon({
  autofitbounds = false,
  color,
  polygonId,
  outlineId
}) {

  function addLayer(map, coords, autofitbounds) {
    if (!coords || coords.length === 0) return
    const polygonData = {
      'id': polygonId,
      'type': 'fill',
      'source': {
        'type': 'geojson',
        'data': {
          'type': 'Feature',
          'geometry': {
            'type': 'Polygon',
            'coordinates': coords
          }
        }
      },
      'layout': {},
      'paint': {
        'fill-color': color,
        'fill-opacity': 0.1
      }
    }
    const outlineData = {
      'id': outlineId,
      'type': 'line',
      'source': {
        'type': 'geojson',
        'data': {
          'type': 'Feature',
          'properties': {},
          'geometry': {
            'type': 'LineString',
            'coordinates': coords[0]
          }
        }
      },
      'paint': {
        'line-color': color,
        'line-width': 2
      }
    }

    map.addLayer(polygonData)
    map.addLayer(outlineData)

    if (autofitbounds) fitBounds(map, outlineData.source.data, autofitbounds)
  }
  function setLayer(map, coords, autofitbounds) {
    if (!coords || coords.length === 0) return
    const polygonData = {
      'type': 'Feature',
      'geometry': {
        'type': 'Polygon',
        'coordinates': coords
      }
    }
    const outlineData = {
      'type': 'Feature',
      'properties': {},
      'geometry': {
        'type': 'LineString',
        'coordinates': coords[0]
      }
    }
    map.getSource(polygonId).setData(polygonData)
    map.getSource(outlineId).setData(outlineData)

    if (autofitbounds) fitBounds(map, outlineData, autofitbounds)
  }
  function fitBounds(map, data, options) {
    if (data.geometry.coordinates.length === 0) return
    map.fitBounds(bbox(data), assign({
      padding: 30,
    }, options))
  }

  return (map, paths) => {

    const coords = boundaryToLngLat(paths)
    if (map.getSource(polygonId)) {
      setLayer(map, coords, autofitbounds)
    } else {
      addLayer(map, coords, autofitbounds)
    }
  }
}

MapboxPolygon.propTypes = {
  paths: PropTypes.array.isRequired
}